export const determinateParameter = (url) =>
  Boolean(url.match(/\d{2,6}[a-zA-Z]*\d{1,6}[a-zA-Z]*/g));
